module.exports = __webpack_public_path__ + "img/nh3.09dd6b9b.svg";